import React from "react"
import PieChart, {
    Legend,
    Series,
    Tooltip,
    Size,
  } from 'devextreme-react/pie-chart';
import { CircularProgress } from "@material-ui/core";

function RingChart(props){
    const {datasource, palette, isLoading} = props;
    return(
        <div style={{display: "flex", flexDirection: "column", rowGap: "1.5rem"}}>
          {isLoading  ? <div style={{height: 225, width: 250, display: "flex", alignItems: "center", justifyContent: "center"}}><CircularProgress style={{color: palette[0]}} size={"3rem"}/></div>
          :
        <PieChart
          innerRadius={0.65}
          id="pie"
          type="doughnut"
          palette={palette}
          dataSource={datasource}
          startAngle={35}
          loadingIndicator={{show: isLoading, text:"Cargando"}}
        >
          <Series argumentField="type" valueField={"value"} hoverStyle={{hatching: {opacity: 100}}}/>
          <Legend visible={false}/>
          <Tooltip enabled={false}/>
          <Size height={200}  width={250}
          />
        </PieChart>
        }
          <div style={{display: "flex", justifyContent:"space-around", alignItems: "center", columnGap: "0.5rem"}}>
                {datasource.map(data=> <div style={{display: "grid", gridTemplateRows: "1fr 1fr", textAlign: "center", columnGap: "0.5rem", alignItems: "center", justifyContent: "center"}}>
                    <div style={{fontWeight: 700}}>{data.value}</div>
                    <div>{data.type}</div>
                </div>)
                }
          </div>
        </div>
    )
}

export {RingChart}